import { format, parseISO } from 'date-fns';

import { dataEmSaoPaulo, diasEntre } from '@alianca/core/shared/dates';

// parseISO lê 'YYYY-MM-DD' como data local; new Date() leria como UTC e voltaria um dia em São Paulo.
export function formatDateBR(isoDate: string): string {
  return format(parseISO(isoDate), 'dd/MM/yyyy');
}

const DATA_SP = new Intl.DateTimeFormat('pt-BR', { timeZone: 'America/Sao_Paulo' });

/** Dia de negócio (`YYYY-MM-DD`) como está; instante convertido para São Paulo. Vazio vira "—". */
export function formatDataBR(valor: string | null | undefined): string {
    if (!valor) return '—';
    return /^\d{4}-\d{2}-\d{2}$/.test(valor) ? formatDateBR(valor) : DATA_SP.format(new Date(valor));
}

const TIME_SP =new Intl.DateTimeFormat('pt-BR', { hour: '2-digit', minute: '2-digit', timeZone: 'America/Sao_Paulo' });

export function formatTimeSP(isoDateTime: string): string {
  return TIME_SP.format(new Date(isoDateTime));
}

const DATA_HORA_SP = new Intl.DateTimeFormat('pt-BR', { dateStyle: 'short', timeStyle: 'short', timeZone: 'America/Sao_Paulo' });

/** Ex.: `26/10/2026, 18:00` (horário de Brasília). */
export function formatDataHoraSP(instante: Date): string {
    return DATA_HORA_SP.format(instante);
}

/** Dias de calendário em São Paulo entre o instante e agora (0 = hoje). */
export const diasDesde = (instante: string, agora: Date) => diasEntre(dataEmSaoPaulo(new Date(instante)), dataEmSaoPaulo(agora));

/** "hoje", "ontem" ou "há N dias", para frases como "Última venda há 3 dias". */
export function haQuanto(instante: string, agora: Date): { hoje: boolean; texto: string } {
    const dias = diasDesde(instante, agora);
    if (dias === 0) return { hoje: true, texto: 'hoje' };
    return { hoje: false, texto: dias === 1 ? 'ontem' : `há ${dias} dias` };
}

const MES = new Intl.DateTimeFormat('pt-BR', { month: 'long', timeZone: 'UTC' });
const MES_CURTO = new Intl.DateTimeFormat('pt-BR', { month: 'short', timeZone: 'UTC' });

/** `AAAA-MM` → "setembro" (ou "set", curto). */
export const nomeDoMes = (competencia: string, curto = false) =>
    (curto ? MES_CURTO : MES).format(new Date(`${competencia}-15T12:00:00Z`)).replace('.', '');

const DIA_E_MES = new Intl.DateTimeFormat('pt-BR', { day: 'numeric', month: 'short', timeZone: 'UTC' });

/** `AAAA-MM-DD` → "10 de nov." */
export const diaEMes = (dia: string) => DIA_E_MES.format(new Date(`${dia}T12:00:00Z`));
